import { RouteNames } from '../../route-names';
import { Permission } from '../../types/permission';

export interface MenuItem {
  name: string;
  authenticated: boolean;
  path: string;
  permission?: Permission;
  icon?: string;
  className?: string;
}
export const MENU_ITEMS: MenuItem[] = [
  {
    name: 'Журнал',
    authenticated: true,
    path: RouteNames.JOURNAL_PAGE,
  },
];

export const DROPDOWN_MENU_ITEMS: MenuItem[] = [];
